import React from 'react';
import { View } from 'react-native';

import { useInView } from './LandingKit';
import { EASE, isWeb } from './landingTokens';

const VARIANTS = {
  rise: { translateY: 28, opacity: 0, duration: 820 },
  soft: { translateY: 14, opacity: 0, duration: 700 },
  fade: { translateY: 0, opacity: 0, duration: 900 },
};

/**
 * Reveals content the first time it scrolls into view.
 *
 * Web-only enhancement — on native, when reduced motion is preferred, or when
 * IntersectionObserver is unavailable, content renders immediately.
 */
function Reveal({ children, delay = 0, variant = 'rise', style }) {
  const [ref, inView] = useInView();
  const motion = VARIANTS[variant] || VARIANTS.rise;

  return (
    <View
      ref={ref}
      style={[
        style,
        isWeb ? {
          opacity: inView ? 1 : motion.opacity,
          transform: [{ translateY: inView ? 0 : motion.translateY }],
          transition: `opacity ${motion.duration}ms ${EASE} ${delay}ms, transform ${motion.duration}ms ${EASE} ${delay}ms`,
        } : null,
      ]}
    >
      {children}
    </View>
  );
}

export default React.memo(Reveal);
